<template>
  <div>
    <h1 class="title-1">{{ $t('admin.department.create') }}</h1>

    <div class="create-container">
      <validation-observer v-slot="{ handleSubmit }">
        <form id="createDepartment" @submit.prevent="handleSubmit(save)">
          <form-component
            v-model="name"
            input-type="input"
            name="name"
            :label="$t('fields.name')"
            rules="required"
            type="text"
            data-cy="dep-name"
          />

          <form-component
            v-model="missionStatement"
            input-type="textarea"
            name="missionStatement"
            :label="$t('fields.missionStatement')"
            rules="required"
            data-cy="dep-missionStatement"
          />

          <form-component
            v-model="organization"
            input-type="select"
            name="organization"
            :label="$t('admin.department.parentOrganisation')"
            select-label="name"
            rules="required"
            :select-options="organizations"
            data-cy="dep-parentOrg"
          />
        </form>
      </validation-observer>

      <div class="button-row">
        <button class="btn btn--icon btn--pri" form="createDepartment" :disabled="loading" data-cy="btn-createDep">
          <i class="icon fa fa-fw fa-save" />
          {{ $t('btn.create') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from '@/config/firebaseConfig';
import Department from '@/db/Department';
import { mapState } from 'vuex';
import findSlugAndRedirect from '@/util/findSlugAndRedirect';

export default {
  name: 'CreateDepartment',

  data: () => ({
    name: '',
    missionStatement: '',
    organization: null,
    loading: false,
  }),

  computed: {
    ...mapState(['organizations']),
  },

  methods: {
    async save() {
      const { name, missionStatement, organization } = this;
      const data = {
        name: name.trim(),
        missionStatement: missionStatement.trim(),
        organization: db.collection('organizations').doc(organization.id),
        archived: false,
      };

      this.loading = true;

      try {
        const depRef = await Department.create(data);

        await findSlugAndRedirect(depRef);

        this.$toasted.show(this.$t('toaster.add.department'));
      } catch (error) {
        this.$toasted.error(this.$t('toaster.error.department'));
        throw new Error(error);
      }

      this.loading = false;
    },
  },
};
</script>
